import { EventConfig, EventFactory } from './eventFactory.interface';

export const createName = (...args: (string | undefined)[]) => args.filter(Boolean).join('-');

/**
 * function creates factory for semantic events
 * @param params default event params or name
 * @param mapper function to transform event payload
 * @return SemanticEvent factory
 */
export const createEventFactory = <T = void, M = T>(params: EventConfig, mapper?: (payload: M) => T): EventFactory<T, M> => {
  const eventFactory = (payload: M) => {
    const event = {
      timestamp: Date.now(),
      ...params,
      payload: mapper ? mapper(payload as M) : (payload as unknown as T),
    };
    Object.defineProperties(event, {
      [Symbol.toPrimitive]: {
        enumerable: false,
        value: () => `${event.timestamp}: ${event.name}`,
      },
    });
    return event;
  };
  eventFactory.eventName = params.name;
  return eventFactory;
};
